
import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { makeStyles } from '@mui/styles';
import axios from 'src/utils/axios';
import Page from 'src/components/Page';
import Header from './Header';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { Box, Button, Card, CardContent, CardHeader, Grid, TextField, Divider } from "@mui/material";
import businessService from 'src/services/businessService';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: 100
  },
  formContainer: {
    marginTop: theme.spacing(3),
  },
  inputField: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  mapButton: {
    marginTop: theme.spacing(2),
  },
  mapContainer: {
    width: '100%',
    height: '400px',
  }
}));

function UpdateBusinessLocation() {
  // Remove the static statuses for state dropdown if using dynamic state list
  const classes = useStyles();
  const { state } = useLocation();
const [pinCodeList, setPinCodeList] = useState([]);  // Holds the list of pin codes
const [address, setAddress] = useState(""); 
  const [deliverychargesInfo, setDeliverychargesInfo] = useState({});
  const [businessLocation, setBusinessLocation] = useState({
    state: '',
    city: [{ cityName: '', cityCode: '', areaCode: [] }],
    coordinates: { type: [0, 0] }, // [longitude, latitude]
  });
  const [stateList, setStateList] = useState([]); // new state for the state list
const [cityList, setCityList] = useState([]); // Holds the list of cities

  const [showMap, setShowMap] = useState(false);
  const [selectedCoordinates, setSelectedCoordinates] = useState({ lat: 0, lng: 0 });
  const [isInfoWindowOpen, setIsInfoWindowOpen] = useState(false);

  async function getDeliverychargesInfo(cid) {
    console.log("AddDeliveryCharges.getDeliverychargesInfo() :: cid: ", cid);
    let axiosUrl = `/api/admin/order/get/delivery-charges`;
    if (cid !== undefined && cid !== null && cid !== "" && cid !== 0) {
      axiosUrl = `${axiosUrl}?customerId=${cid}`;
    }
    const axiosConfig = {};
    try {
      const response = await axios.get(axiosUrl, axiosConfig);
      const result = (response?.data?.data?.deliverycharges) ? response.data.data.deliverycharges[0] : {};
      console.log("AddDeliveryCharges.getDeliverychargesInfo() :: result: ", result);
      setDeliverychargesInfo(result);
    } catch (error) {
      console.error(error);
    }
  }

  // Call both getDeliverychargesInfo and fetchStateList on component load
useEffect(() => {
  getDeliverychargesInfo(state.customerId);
  businessService.fetchStateList()
    .then((response) => {
      console.log("State List fetched:", response);
      // Extract the states array from the response
      setStateList(response.states || []);
    })
    .catch((error) => {
      console.error("Error fetching state list:", error);
    });
}, [state.customerId]);


 // When the state selection changes, update businessLocation and fetch cities
  const handleBusinessLocationChange = (e) => {
    const { name, value } = e.target;
    setBusinessLocation((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "state") {
      // Find the selected state from stateList
      const selectedState = stateList.find(item => item.stateId === value);
      if (selectedState) {
          const stateCode = selectedState.stateCode;
        // Call the API using the state's code (assumed to be in selectedState.stateCode)
       businessService.fetchCityList(stateCode)
  .then((cityResponse) => {
    console.log("Full City Response:", cityResponse);
    const cities = cityResponse.cities || cityResponse || [];
    setCityList(cities);
  })
  .catch((error) => {
    console.error("Error fetching city list:", error);
    setCityList([]);
  });
      } else {
        setCityList([]);
      }
    }
  };


const handleCityChange = (index, e) => {
  const { name, value } = e.target;
  const newCities = [...businessLocation.city];
  newCities[index][name] = value;
  if (name === "cityName") {  // Check for "cityName" now
    const selectedCity = cityList.find(city => city.cityName === value);
    newCities[index]["cityCode"] = selectedCity ? selectedCity.cityCode : "";
     if (selectedCity && selectedCity.cityCode) {
      fetchPinCodeList(selectedCity.cityCode);
    }
  }
  setBusinessLocation((prevState) => ({
    ...prevState,
    city: newCities,
  }));
};

// Add this function to fetch pin codes based on cityCode
const fetchPinCodeList = (cityCode) => {
  const filteredCityCode = cityCode.replace("std:", "");
  // Assuming `businessService.fetchPinCodeList` is the service function to call the API
  businessService.fetchPincodeList(filteredCityCode)
    .then((response) => {
      console.log("Pin Code List Response:", response);
       const pinCodes = Array.isArray(response?.data) ? response.data : [];
      setPinCodeList(pinCodes);  // Update the state with pin code list
    })
    .catch((error) => {
      console.error("Error fetching pin code list:", error);
      setPinCodeList([]);  // Clear pin code list on error
    });
};


  const addNewCity = () => {
    setBusinessLocation((prevState) => ({
      ...prevState,
      city: [...prevState.city, { cityName: '', cityCode: '', areaCode: [] }],
    }));
  };

  const handleSelectCoordinates = (lat, lng) => {
    setSelectedCoordinates({ lat, lng });
    setBusinessLocation((prevState) => ({
      ...prevState,
      coordinates: { type: [lng, lat] },
    }));
    setIsInfoWindowOpen(false); // Close info window after selection
    setShowMap(false); // Close map after selecting coordinates
  };

  const handleMapClick = (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    setSelectedCoordinates({ lat, lng });
    setIsInfoWindowOpen(true); // Show info window on map click
  };

  return (
    <Page className={classes.root} title="Add Delivery Charges">
      <Header />
      <div className={classes.formContainer}>
        <CardHeader title="Business Location" />

        <div>
          <Card style={{ marginLeft: "2em", width: "600px" }}>
            <CardHeader title="State" />
            <Divider />
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel id="state-select-label">Select State</InputLabel>
                   <Select
  labelId="state-select-label"
  id="state-select"
  label="Select State"
  name="state"
  value={businessLocation.state}
  onChange={handleBusinessLocationChange}
>
  {stateList.length > 0 ? (
    stateList.map((stateItem) => (
      <MenuItem key={stateItem.stateId} value={stateItem.stateId}>
        {stateItem.stateName}
      </MenuItem>
    ))
  ) : (
    <MenuItem value="">
      <em>No States Available</em>
    </MenuItem>
  )}
</Select>

                  </FormControl>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </div>

        {/* The rest of your component remains unchanged */}
        <div>
          <CardHeader title="" />
          <Card style={{ marginLeft: "2em", width: "600px" }}>
            <CardHeader title="Cities" />
            <Divider />
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel id="city-select-label">Select City</InputLabel>
                 <Select
  labelId="city-select-label"
  id="city-select"
  label="Select City"
  name="cityName"   // Change from "city" to "cityName"
  value={businessLocation.city[0].cityName}
  onChange={(e) => handleCityChange(0, e)}
>
  {cityList.length > 0 ? (
    cityList.map((cityItem) => (
      <MenuItem key={cityItem.cityId} value={cityItem.cityName}>
        {cityItem.cityName}
      </MenuItem>
    ))
  ) : (
    <MenuItem value="">
      <em>No Cities Available</em>
    </MenuItem>
  )}
</Select>


                  </FormControl>
                </Grid>
              </Grid>


              <CardHeader title="" />
              <Grid container spacing={3}>
                <Grid item xs={12}>
                <FormControl fullWidth>
  <InputLabel id="area-code-select-label">Select Area Code</InputLabel>
  <Select
    labelId="area-code-select-label"
    id="area-code-select"
     label="Select areaCode"
    name="areaCode"
     value={businessLocation.city[0].areaCode || ""} 
    onChange={(e) => handleCityChange(0, e)}
  >
   {pinCodeList.length > 0 ? (
      pinCodeList.map((pin) => (
        <MenuItem key={pin} value={pin}>
          {pin}
        </MenuItem>
      ))
    ) : (
      <MenuItem value="">
        <em>No Area Codes Available</em>
      </MenuItem>
    )}
   
  </Select>
</FormControl>

                 
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </div>

        <div>
          <Card style={{ marginLeft: "2em", width: "600px", marginTop: "30px" }}>
            <CardHeader title="Coordinates (Longitude, Latitude)" />
            <Divider />
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Enter address"
                    name="address"
                    value={address}
                    variant="outlined"
                    onChange={(e) => setAddress(e.target.value)} 
                  />
                </Grid>
                <Grid item xs={12}>
                  {/* <Button
                    variant="contained"
                    color="primary"
                    className={classes.mapButton}
                    onClick={() => setShowMap(true)}
                  >
                    Get Coordinates
                  </Button> */}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </div>

     
      </div>
    </Page>
  );
}

export default UpdateBusinessLocation;
